import { JsonSchema, UISchemaElement } from '@jsonforms/core'
import { authSelectors } from 'ducks/auth'
import { useDataProvider } from 'ra-core'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

// store statically to avoid multiple requests
let staticStructTypes: undefined | StructType[] = undefined

export const useStructTypes = () => {
  const isStaff = useSelector(authSelectors.getIsStaff)
  const dataProvider = useDataProvider()
  const [structTypes, setStructTypes] = useState<undefined | StructType[]>(undefined)

  useEffect(() => {
    if (!isStaff) {
      setStructTypes([])
      return
    }
    if (staticStructTypes) {
      setStructTypes(staticStructTypes)
    }
    // @ts-ignore
    dataProvider.getList('struct-types', { filter: { include: 'schema,uischema,default' } }).then((response) => {
      staticStructTypes = response.data as StructType[]
      setStructTypes(staticStructTypes)
    })
  }, [isStaff])

  return structTypes
}
export type StructType = {
  id: string
  title: string
  singular?: boolean
  schema?: JsonSchema
  uischema?: UISchemaElement
  versioning?: object
  default?: object
}
